import React from "react"

//Utils
import Helmet from "react-helmet"
import Seo from "components/seo"

//Components
import Layout from "components/layout"
import LayoutGeneral from "components/layout-general-page"
import { getServerAuthenticated } from "lib/utils/get-sever-authentication"
import ContactUsComp from "components/pages/contact"
import { useRouter } from "next/router"
import { useSelector, useDispatch } from "react-redux"

const Contact = () => {
  return (
    <>
      <Seo title="Contact Us" />
      <Layout>
        <ContactUsComp />
      </Layout>
    </>
  )
}

export default Contact
